// extracted by mini-css-extract-plugin
export default {"row":"CustomTableRow_row__DSFTI","row--clickable":"CustomTableRow_row--clickable__MUcWF","row__iconCell":"CustomTableRow_row__iconCell__922VS"};